{
	"access": {
		"ability": {
			"admins_manage": "Manage admins",
			"call_manage": "Manage the call",
			"call_monitor": "Follow the calls and remind the managers",
			"email_texts_manage": "Edit email texts",
			"event_log_read": "Read the event log",
			"residences_manage": "Manage residences",
			"sending_monitor": "Follow the sendings and their anomalies",
			"support_manage": "Assist students",
			"users_manage": "Manage users"
		},
		"copy_user_id": "Copy user ID",
		"no_permissions": "No permissions",
		"permissions": "Permissions",
		"sign_in_method": "Sign-in method",
		"source": {
			"invite_accept": "Invite",
			"password": "Password",
			"password_reset": "Password reset"
		},
		"title": "Access",
		"user_id": "User ID"
	},
	"account": {
		"email_field": {
			"change_success": "Your email address has been updated.",
			"code_sent_new": "We sent a verification code to {{email}}.",
			"codes_sent_both": "We sent a code to {{currentEmail}} and to {{email}}.",
			"confirm_button": "Confirm email change",
			"current_code_label": "Code from your current email",
			"new_code_label": "Code from the new email",
			"validation": {
				"invalid": "Enter a valid email address.",
				"unchanged": "Enter a new email different from the current one."
			}
		},
		"personal_data": {
			"name_max": "Name must be at most 100 characters.",
			"name_required": "Enter your name."
		},
		"update_success": "Profile updated successfully."
	},
	"security": {
		"access": {
			"change_email": "Change email",
			"description": "Update the password used to sign in to your account.",
			"error": "Failed to update password. Please try again.",
			"otp_hint": "We'll email you a code to authorize the password change.",
			"submit": "Update password",
			"success": "Password updated successfully.",
			"title": "Access",
			"two_factor": {
				"email_code_sent": "Verification code sent. Check your inbox.",
				"email_resend_code": "Resend code",
				"email_send_code": "Send code",
				"verify": "Verify",
				"verify_label": "Verification code"
			},
			"validation": {
				"max": "Password must be at most 255 characters."
			}
		},
		"email": {
			"title": "Email"
		},
		"password": {
			"title": "Password"
		},
		"sessions": {
			"current_badge": "This device",
			"description": "Review the devices currently signed in to your account and revoke any you don't recognize.",
			"empty": "No active sessions found.",
			"error": "Failed to load sessions.",
			"revoke": "Sign out",
			"revoke_success": "Signed out from device.",
			"signed_in": "Signed in {{date}}",
			"title": "Active sessions",
			"unknown_device": "Unknown device"
		}
	},
	"title": "Profile"
}
